import React from 'react';
import Pinpoints from './Pinpoints';

export default function Hero({ onShowQuote }) {
  return (
    <section id='home' className='am-intro hero'>
      <div className='am-right am-hero-visual'>
        <img className='am-hero-main' alt='Cleaning cart' src='/assets/cleaning_cart_with_eco_logo.png' />
      </div>
      <div className='am-left'>
        <div className='am-hero-copy'>
          <h2 className='am-hero-title'>
            Cleaning services in Toronto & GTA
            <br />
            Your Trusted Cleaning Company for Homes, Condos, and Offices. Free Quote in Seconds.
          </h2>
          <p className='am-hero-sub'>
            Whether you need your home or office sparkling clean, a thorough home maintenance inspection, or an eviction
            inspection, AM Facilities is here to provide reliable, professional services.
          </p>

          <Pinpoints
            className='am-hero-list'
            items={[
              '10 years in Property Management',
              '500+ satisfied client with us!',
              '6 years as a Housekeeping Supervisor and Manager',
              'Strategic solutions to maximize efficiency and cost savings',
            ]}
          />

          <div className='am-hero-ctas am-hero-ctas-overlap'>
            <button className='am-chip am-chip-primary am-chip-overlap' onClick={onShowQuote}>
              Get your free quote and book now!
            </button>

            <a className='am-chip am-chip-dark am-chip-overlap' href='#services'>
              Our services
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
